import { trim } from 'fp-ts/string';
import { FormRule } from 'src/modules/form/types/FormRule';
import * as R from 'src/modules/form/utils/rules';

export const SAVE_PROJECT_SCHEMA: FormRule<{ email: string }> = R.struct({
  email: R.map(trim, R.allOf([R.nonEmpty(), R.email()])),
});
